export default "__VITE_ASSET__BdBe6LDz__"